// extracted by mini-css-extract-plugin
export default {"newQuestion":"vwrxE1yFQHrnvlpE","questionSelector":"hxLoJXJgZeF897N_"};